import React from 'react';
import styled from 'styled-components';

import Spinner from '../components/ui-helpers/spinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LoadingModal = () => (
  <Container>
    <Spinner />
  </Container>
);



// WEBPACK FOOTER //
// ./src/modals/loading-modal.js